import React from "react";
import Mydata from "../../data/blog/whyBussiness.json";

function Content() {
  const data = Mydata[3];

  return (
    <div className="space-y-6">
      {" "}
      {/* Add spacing between main content blocks */}
      {data.heading.map((item, index) => (
        <div key={index} className="space-y-4">
          {" "}
          {/* Add spacing between heading and its content */}
          <h2 id={item.id} className="blogtitle">{item.title}</h2>

          {item.content.map((contentItem, contentIndex) => (
            <p
              key={contentIndex}
              className="blogcontent" // Add spacing and line height
              dangerouslySetInnerHTML={{ __html: contentItem }}
            ></p>
          ))}
          {item.subheadings.map((subheading, subIndex) => (
            <div key={subIndex} className="space-y-4 ">
              {" "}
              {/* Add spacing for subheading and indent */}
              {subheading.title && (
                <h3 className="blogSubtitle">{subheading.title}</h3>
              )}

{subheading.des && (
                <p
                  className="blogcontent" // Adjust spacing and line height
                  dangerouslySetInnerHTML={{ __html: subheading.des }}
                ></p>
              )}


              {subheading.content2 && (
                <p
                  className="blogcontent" // Adjust spacing and line height
                  dangerouslySetInnerHTML={{ __html: subheading.content2 }}
                ></p>
              )}
              {subheading.des3 && (
                <p
                  className="blogcontent" // Adjust spacing and line height
                  dangerouslySetInnerHTML={{ __html: subheading.des3 }}
                ></p>
              )}
              {subheading.bulletPoints && (
                <ul className="space-y-2 pl-4">
                  {" "}
                  {/* Add bullet list styling and spacing */}
                  {subheading.bulletPoints.map((bullet, bulletIndex) => (
                    <li
                      key={bulletIndex}
                      className="blogcontent list-disc"
                      dangerouslySetInnerHTML={{ __html: bullet }}
                    ></li>
                  ))}
                </ul>
              )}
              {subheading.Newcontent && <p className="blogcontent">{subheading.Newcontent}</p>}
              {subheading.title22 && <h2 className="blogSubtitle">{subheading.title22}</h2>}
              {subheading.content3 && (
                <p
                  className="blogcontent" // Add spacing and line height
                  dangerouslySetInnerHTML={{
                    __html: subheading.content3,
                  }}
                ></p>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default Content;
